<template>
    <section class="need-help flex-grid-desk">
        <h4 style="font-family:'lora', serif; font-weight: 300; text-align: center; width: 100%; padding-bottom: 20px;">IN CASE OF EMERGENCY IMMEDIATELY CONTACT US AT “EMAIL ASSISTANCE” OR TELEPHONE NUMBER BELOW</h4>
        <div class="alert alert-primary flex-fill m-2">
            <i class="pi pi-envelope pt-4" style="color:#ff0064; font-size: 3rem;"></i>
            <router-link to="/emergency-email"><span>24H EMERGENCY <br class="d-md-none"/>EMAIL ASSISTANCE</span></router-link>
        </div>
        <div class="alert alert-primary flex-fill m-2">
            <i class="pi pi-phone pt-4" style="color:#ff0064; font-size: 3rem;"></i>
            <router-link to="/24h-emergency"><span>24H EMERGENCY <br class="d-md-none"/>MEDICAL ASSISTANCE</span></router-link>
        </div>
    </section>
</template>

<script>
export default {
    
}
</script>